import { render } from "./ModalEditarTarefa.vue?vue&type=template&id=c4d1b8de&scoped=true"
import script from "./ModalEditarTarefa.vue?vue&type=script&lang=js"
export * from "./ModalEditarTarefa.vue?vue&type=script&lang=js"

import "./ModalEditarTarefa.vue?vue&type=style&index=0&id=c4d1b8de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4d1b8de"]])

export default __exports__